
import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import WebsiteContentField from '../../components/WebsiteContentField';

export default class EditDomainForm extends React.Component {

  requiredFields = ["title"]

  constructor(props) {
    super(props)
    this.state = {
      domainName: ''
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  onFieldChange = (propertyName, value) => {
    let s = {
      ...this.state,
      [propertyName]: value
    };
    this.setState(s);
  }

  onSubmit() {
    this.props.onSubmit(this.state);
  }

  render() {

    const actions = [
      <FlatButton
        label="Cancel"
        primary={false}
        keyboardFocused={true}
        onTouchTap={this.props.onClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.onSubmit}
      />,
    ];
    return (
      <Dialog
          title='Add Domain'
          actions={actions}
          modal={true}
          open={this.props.show}
          onRequestClose={this.onClose}
      >
          <WebsiteContentField label="Domain" icon="link" value={this.state.domainName} onChange={(value)=> this.onFieldChange('domainName', value)} type="text" />
      </Dialog>
    );

  }


}



// WEBPACK FOOTER //
// ./src/containers/Website/EditDomainForm.js